module.exports = __webpack_public_path__ + "static/media/20160701_141844.4e55a3e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20160701_141844.jpg
// module id = 452
// module chunks = 0